import firebase from 'firebase/app';

export class User {
  constructor(
    public uid: string = '',
    public name: string = '',
    public email: string = '',
    public createdIn = firebase.firestore.Timestamp.now(),
  ) {

  }

  static userFromAuthUser(user: firebase.User) {
    return new User(
      user.uid,
      user.displayName ?? 'Sem Nome',
      user.email!
    )
  }

}
